import type { UserLimits, UserTariffPurchase } from "../../api/user";
import { getPurchaseDate } from "../../api/user";
import {
  formatCheckPacksSummary,
  formatLimitsDelta,
  formatPurchaseDate,
  formatPurchasePrice,
  formatPurchaseStatus,
  formatPurchaseTitle,
  formatUserLimitsPeriodRange,
  getPurchaseTypeLabel,
  getUserLimitsEntitlementRows,
  getUserLimitsStatusBadge,
  getUserLimitsUsageRows,
} from "../../utils/userLimitsFormat";
import "./AdminUserLimitsBlock.scss";

const InfoLine = ({ label, value }: { label: string; value: string }) => (
  <div className="admin-user-limits-line">
    <span className="admin-user-limits-line-label">{label}</span>
    <span className="admin-user-limits-line-value">{value}</span>
  </div>
);

export const AdminUserLimitsBlock = ({ limits }: { limits?: UserLimits | null }) => {
  if (!limits) {
    return <span className="admin-user-tariff-empty">—</span>;
  }

  const badge = getUserLimitsStatusBadge(limits);
  const usageRows = getUserLimitsUsageRows(limits);
  const entitlements = getUserLimitsEntitlementRows(limits);

  return (
    <div className="admin-user-limits-block">
      <div className="admin-user-limits-head">
        <span className="admin-user-limits-title">Текущий период</span>
        <span
          className={`admin-user-tariff-badge${
            badge === "Активен" ? " admin-user-tariff-badge--active" : ""
          }`}
        >
          {badge}
        </span>
      </div>
      <div className="admin-user-limits-details">
        <InfoLine label="Период" value={formatUserLimitsPeriodRange(limits)} />
        {usageRows.length === 0 ? (
          <InfoLine label="Лимиты" value="Нет данных" />
        ) : (
          usageRows.map((row) => <InfoLine key={row.key} label={row.label} value={row.value} />)
        )}
        {entitlements.length > 0 ? (
          <InfoLine
            label="Типы"
            value={entitlements
              .map((item) => {
                const opts = item.options.length ? ` (${item.options.join(", ")})` : "";
                return `${item.label}${opts}`;
              })
              .join("; ")}
          />
        ) : null}
      </div>
    </div>
  );
};

export const AdminUserPurchaseHistoryList = ({
  items,
}: {
  items?: UserTariffPurchase[] | null;
}) => {
  if (!items?.length) {
    return <p className="admin-user-modal-empty">История покупок пуста</p>;
  }

  return (
    <div className="admin-user-purchase-list">
      {items.map((purchase, index) => (
        <div
          key={`${purchase.payId ?? getPurchaseDate(purchase) ?? "purchase"}-${index}`}
          className="admin-user-limits-block"
        >
          <div className="admin-user-limits-head">
            <span className="admin-user-limits-title">{formatPurchaseTitle(purchase)}</span>
            <span className="admin-user-tariff-badge">{getPurchaseTypeLabel(purchase)}</span>
          </div>
          <div className="admin-user-limits-details">
            <InfoLine label="Дата" value={formatPurchaseDate(purchase)} />
            <InfoLine label="Стоимость" value={formatPurchasePrice(purchase)} />
            {purchase.status ? (
              <InfoLine label="Статус" value={formatPurchaseStatus(purchase.status)} />
            ) : null}
            {purchase.tariffType === "checks" ? (
              <InfoLine label="Состав" value={formatCheckPacksSummary(purchase.checkPacks)} />
            ) : (
              <InfoLine label="Лимиты" value={formatLimitsDelta(purchase.limitsDelta)} />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
